import React from 'react';
import { TabbedShowLayout, Tab, TextField, ReferenceField, ReferenceManyField, Pagination, BooleanField, useRecordContext } from 'react-admin';
import Box from '@mui/material/Box';

import Show, { ShowActions } from '../common/views/Show';
import DateField from '../common/fields/DateField';
import InvoiceRow from '../invoices/InvoiceRow';
import CheckPeppolButton from './CheckPeppolButton';

const InvoiceList = (props) => (
	<Box>
		<ReferenceManyField {...props} reference="invoices" target="invoicing_address_id" pagination={<Pagination />} filter={{ archived: false }}>
			<InvoiceRow />
		</ReferenceManyField>
	</Box>
);

const AddressActions = (props) => {
	const record = useRecordContext();

	return (
		<ShowActions {...props}>
			<CheckPeppolButton record={record} />
		</ShowActions>
	);
};

const AddressShow = props => (
	<Show {...props} actions={<AddressActions />}>
		<TabbedShowLayout>
			<Tab label="summary">
				<TextField source="name" />
				<TextField source="vat_number" />
				<ReferenceField label="Customer" source="customer_id" reference="customers" link="show" allowEmpty>
					<TextField source="name" />
				</ReferenceField>
				<TextField source="street" />
				<TextField source="street_bis" />
				<TextField source="number" />
				<TextField source="box" />
				<TextField source="zipcode" />
				<TextField source="city" />
				<TextField source="country" />
				<TextField source="email" />
				<TextField source="phone" />
				<BooleanField label="On PEPPOL" source="is_present_on_peppol" />
				<TextField label="PEPPOL Identifier" source="peppol_identifier" />
				<DateField label="PEPPOL Checked At" source="peppol_checked_at" />
				<TextField label="Invoice Delivery" source="invoice_delivery_method" />
			</Tab>
			<Tab label="Invoices" path="invoices">
				<InvoiceList label={false} />
			</Tab>
		</TabbedShowLayout>
	</Show>
);

export default AddressShow;